module.exports = require("date-fns/parse");


//////////////////
// WEBPACK FOOTER
// external "date-fns/parse"
// module id = 37
// module chunks = 0